import React, { useState, useEffect,memo } from 'react';
import type { FC, ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom'; // useLocationを追加
import classes from './Navigation.module.scss';
import { Language } from "./Language/Language";
import { ArrowIcon } from '../Button/Button_circle/ArrowIcon';
import { Button_contact } from "../Button/Button_contact/Button_contact";
import Logo from "../../../assets/images/hADO_logo312.png";
import { useTranslation } from 'react-i18next';

interface Props {
  className?: string;
  classes?: {
    root?: string;
  };
}

export const Navigation: FC<Props> = memo(function Navigation(props = {}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isLanguageReady, setIsLanguageReady] = useState(false);
  const { t, i18n } = useTranslation();
  const location = useLocation(); // 現在のロケーションを取得
  
  // パスから期待される言語を取得
  const pathSegments = location.pathname.split('/').filter(segment => segment !== '');
  const expectedLanguage = pathSegments[0] || 'ja';
  
  useEffect(() => {
    // i18nの言語変更を監視
    const handleLanguageChange = (lng: string) => {
      if (lng === expectedLanguage) {
        setIsLanguageReady(true);
      }
    };
    
    // 初期状態をチェック
    if (i18n.language === expectedLanguage) {
      setIsLanguageReady(true);
    }
    
    // イベントリスナーを追加
    i18n.on('languageChanged', handleLanguageChange);
    
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [expectedLanguage]);
  
  // 現在の言語コードを取得
  const langCode = i18n.language; // i18nから現在の言語を取得

  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [menuOpen]);

  // 言語が準備できていない場合は待機
  if (!isLanguageReady) {
    return null;
  }

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };



  return (
    <nav className={`${classes.navigationBar} ${props.className || ''}`}>
      <div className={classes.hadoLogo} onClick={closeMenu}><Link to={`/${langCode}`}><img src={Logo} alt="Logo" /></Link></div>
      <Language className={classes.languageSwitcher} />
      <button className={classes.menuToggle} onClick={toggleMenu}>
        <div className={`${classes.menuIcon} ${menuOpen ? classes.open : ''}`}>
          <span className={classes.bar}></span>
          <span className={classes.bar}></span>
          <span className={classes.bar}></span>
        </div>
      </button>
      <ul className={`${classes.navMenu} ${menuOpen ? classes.open : ''}`}>
      <li className={classes.navItem} onClick={closeMenu}><Link to={`/${langCode}/about`}>{t('common:header.about')}<span className={`arrow1 ${classes.arrowIcon}`} ><ArrowIcon className={classes.icon} /></span></Link></li>
        <li className={classes.navItem} onClick={closeMenu}><Link to={`/${langCode}/student-club`}>{t('common:header.studentclub')}<span className={`arrow1 ${classes.arrowIcon}`} ><ArrowIcon className={classes.icon} /></span></Link></li>
        <li className={classes.navItem} onClick={closeMenu}><Link to={`/${langCode}#interview`}>{t('common:header.interviews')}<span className={`arrow1 ${classes.arrowIcon}`} ><ArrowIcon className={classes.icon} /></span></Link></li>
        <li className={classes.navItem} onClick={closeMenu}><Link to={`/${langCode}/post/6634`}>{t('common:header.research-result')}<span className={`arrow1 ${classes.arrowIcon}`} ><ArrowIcon className={classes.icon} /></span></Link></li>
        <li className={classes.contactLink} onClick={closeMenu}><Link to={t('common:header.contact_url')} target='_blank'>{t('common:header.contact')}</Link>
        </li>
        <li><Button_contact className={classes.contactButton} /></li>
      </ul>
      
    </nav>
  );
});








